import { render, staticRenderFns } from "./StatementOfUse.vue?vue&type=template&id=dce299dc&scoped=true"
import script from "./StatementOfUse.vue?vue&type=script&lang=js"
export * from "./StatementOfUse.vue?vue&type=script&lang=js"
import style0 from "./StatementOfUse.vue?vue&type=style&index=0&id=dce299dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce299dc",
  null
  
)

export default component.exports